import React from 'react';

const ComponentHeading = ({ label, icon }) => {
    const Icons = icon ? icon : null;

    return (
        <div className="w-full mb-4 sm:mb-3 select-none">
            <div className="flex items-center gap-2.5">
                {Icons && (
                    <span className="flex items-center justify-center w-8 h-8 rounded-lg bg-customPrimary/10 dark:bg-customPrimary/15 shrink-0">
                        <Icons className="text-[17px] text-customPrimary" />
                    </span>
                )}
                <span className="font-public-sans font-bold text-[15px] leading-none tracking-tight text-slate700 dark:text-white whitespace-nowrap">
                    {label}
                </span>
            </div>

            {/* Divider with a primary-color accent marking the section start */}
            <div className="relative mt-3 h-px w-full bg-slate200 dark:bg-slate700 overflow-hidden rounded-full">
                <span className="absolute left-0 top-0 h-full w-10 bg-customPrimary" />
            </div>
        </div>
    )
}

export default ComponentHeading